import { createClient } from "@supabase/supabase-js";

const supabaseUrl = 'https://bookgahagfyeyjkjwmkr.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJvb2tnYWhhZ2Z5ZXlqa2p3bWtyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjcyNjMxMTYsImV4cCI6MjA0MjgzOTExNn0.bmngRJKGThqSDnnC2OHEYAljLBQoGiabg_CJMzVSZh4';

export default createClient(supabaseUrl, supabaseKey);
        